module.exports = __webpack_public_path__ + "img/savology-screen-6.ce77a3d9.png";